import { EditPageItemNameEditorState } from '../../typings/editPageItemNameEditor';

export const getDefaultEditPageItemNameEditorState = (): EditPageItemNameEditorState => {
    return {
        value: '',
        isVisible: false
    };
};
